import StoreModuleService from '../../../StoreModuleService';
import { MODULE_NAME } from './const';

const buildInstallablesVersionsGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const getInstallableVersions = buildInstallablesVersionsGetterObject('getInstallableVersions');
export const getInstallableVersion = buildInstallablesVersionsGetterObject('getInstallableVersion');

const getters = {
	[getInstallableVersions.getter]: (state) => (installableId) => state.versionsOfInstallables[installableId] || {},
	[getInstallableVersion.getter]: (state, getters) => (installableId, installableVersionId) =>
		getters[getInstallableVersions.getter](installableId)[installableVersionId],
};

export default getters;
